import { useEffect } from 'react';

/**
 * Hook to enable component debug mode with Ctrl+Shift+L
 * Toggles visual highlighting of all elements with data-component and data-flow attributes
 */
export const useDebugMode = () => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl+Shift+L to toggle debug mode
      if (e.ctrlKey && e.shiftKey && e.key === 'L') {
        e.preventDefault();
        document.body.classList.toggle('debug-mode');
        
        // Optional: Log state change
        const isActive = document.body.classList.contains('debug-mode');
        console.log(`Debug mode: ${isActive ? 'ON' : 'OFF'}`);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};
